import React from 'react';
import AnimatedSection from './AnimatedSection';
import './SharedStyles.css';
import './LegalDocumentation.css';

const LegalDocumentation = () => {
  const pdfPath = '/docs/business license.pdf';

  return (
    <AnimatedSection direction="scale" className="legal-section" delay={100} id="legal">
      <div className="section-content-wrapper">
        <h2 className="section-title">
          Legal part & <span className="title-accent">documentation</span>
        </h2>

        <div className="license-card">
          <div className="license-header">
            <div className="license-badge">
              <span className="badge-icon">📄</span>
              <span>Official License</span>
            </div>
            <h3 className="license-title">Business License</h3>
          </div>

          <div className="pdf-container">
            <iframe
              src={`${pdfPath}#toolbar=0`}
              className="pdf-viewer"
              title="Business License"
              type="application/pdf"
            />
            <div className="pdf-fallback">
              <p className="fallback-text">
                If the PDF does not display in your browser, please open this page in a desktop browser or contact us for assistance.
              </p>
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>
  );
};

export default LegalDocumentation;
